export const resolution = [16, 9];

export const mobileConfig = {
  width: 750,
  height: 1334,
  bgScale: 1,
  textureScale: .5,
  get bgPosition() {
    return {
      x: this.width / 2,
      y: this.height / 2,
    };
  },

  get staticAnimationPosition() {
    return {
      x: this.width / 2,
      y: this.height,
    };
  },

  get boomAnimationPosition() {
    return {
      x: 0,
      y: this.height / 2 - 80,
    };
  },

  get config() {
    return {
      width: this.width,
      height: this.height,
    };
  },
};

export const webConfig = {
  width: 1920,
  height: 1080,

  get staticAnimationPosition() {
    return {
      x: this.width / 2,
      y: this.height,
    };
  },

  get boomAnimationPosition() {
    return {
      x: 0,
      y: this.height / 2 - 170,
    };
  },

  get config() {
    return {
      width: this.width,
      height: this.height,
    };
  },
};


export const landScapeConfig = {
  width: 1920,
  height: 1080,

  get staticAnimationPosition() {
    return {
      x: this.width / 2,
      y: this.height,
    };
  },

  get bgPosition() {
    return {
      x: 0,
    };
  },

  get config() {
    return {
      width: this.width,
      height: this.height,
    };
  },
};
